export default {
  basic: 'Basic',
  full: 'Full',
}
